import { useRoute } from 'vue-router';
import { computed } from 'vue';

export function useKioskRoute() {
	const route = useRoute();

	const kioskId = computed(() => route.params.kioskId);

	const makePath = (path) => {
		const separator = path.startsWith('/') ? '' : '/';
		return `/${kioskId.value}${separator}${path}`;
	};

	const makeNamedRoute = (name, params = {}, query = {}) => {
		return {
			name,
			params: {
				kioskId: kioskId.value,
				...params,
			},
			query: {
				...query,
			},
		};
	};

	return {
		kioskId,
		makePath,
		makeNamedRoute,
	};
}
